<script lang="ts" setup>
  import { storeToRefs } from 'pinia'
  import { RouteLocation } from 'vue-router'
  import ViewShell from '~/components/ViewShell/ViewShell.vue'
  import { definePageMeta } from '#imports'
  import { useGameContentStore } from '~/store/GameContent'
  import { ViewShellFacet } from '~/components/ViewShell/ViewShellFacet'
  import { MiddlewareKey } from '#build/types/middleware'
  import useGameLogic from '~/composables/GameLogic/GameLogic'

  const gameContentStore = useGameContentStore()
  const { cityContent } = storeToRefs(gameContentStore)
  const { handleStartNotification } = useGameLogic()

  definePageMeta({
    key: (route: RouteLocation) => route.fullPath,
    layout: 'game-with-sidebar',
    middleware: process.client ? ['game' as MiddlewareKey, 'city'] : ['city'],
  })

  onMounted(handleStartNotification)
</script>

<template>
  <div class="c-page s-page s-page--fill u-typography-root">
    <ViewShell
      :height="900"
      :width="1200"
      :background="cityContent?.illustration"
      :facets="[ViewShellFacet.City]"
    >
      <template #content="{ width, height }">
        <ImageMapCity
          v-if="cityContent"
          :city-id="cityContent.id"
          :height="height"
          :width="width"
        />
      </template>
      <template #debug />
    </ViewShell>
  </div>
</template>
